import {list, update} from 'message-control/services/sensitive-notification'
import createModel from 'utils/model'

export default createModel({
    namespace: 'messageControl_sensitiveNotification',

    state: {
        tableData: {},
    },

    effects: {
        *list(_, {call, put}) {
            const res = yield call(list)
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                },
            })
            return res
        },
        *update({payload}, {call}) {
            return yield call(update, payload)
        },
    },

    reducers: {},
})
